import { render } from "./BannerAction.vue?vue&type=template&id=0b4061a0&scoped=true"
import script from "./BannerAction.vue?vue&type=script&lang=js"
export * from "./BannerAction.vue?vue&type=script&lang=js"

import "./BannerAction.vue?vue&type=style&index=0&id=0b4061a0&lang=scss&scoped=true"

import exportComponent from "/Users/skynet/Documents/Sites Safe OK MAIS PEUT ETRE PAS A JOUR/Safe_Sites_Modifs/SAFE_BO/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b4061a0"]])

export default __exports__